var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['columns ugc-new-steps-view-instructions', {
      'small-10 medium-8 small-offset-1 medium-offset-2': this.$store.state.utils.configuration.enableNewUgcModal
    }]
  }, [_vm._v("\n  " + _vm._s(_vm.getTitle) + "\n")]);
}
var staticRenderFns = []

export { render, staticRenderFns }